import { useEditorRef, withRef } from '@udecode/plate/react';
import { ImageIcon } from 'lucide-react';
import { useFilePicker } from 'use-file-picker';

import { AcceptedImageTypes } from '../../constants';
import { ToolbarButton } from '../common/toolbar.component';

export const ImageToolbarButton = withRef<typeof ToolbarButton>((props, ref) => {
    const editor = useEditorRef();

    const { openFilePicker } = useFilePicker({
        accept: AcceptedImageTypes,
        multiple: true,
        onFilesSelected: (data: any) => {
            if (!data.plainFiles || data.plainFiles.length === 0) return;
            (editor as any).tf.insert.media(data.plainFiles, { removeEmpty: true });
        },
    });

    return (
        <ToolbarButton
            ref={ref}
            onClick={openFilePicker}
            tooltip="Vložit obrázek"
            {...props}
        >
            <ImageIcon />
        </ToolbarButton>
    );
});
